import store from 'state/store';

/**
 * Construct the Basic Auth header field from the username
 * and auth token.
 */
export function authHeaderField(username, token) {
  const encoded = Buffer(`${username}:${token}`).toString("base64");
  return `Basic ${encoded}`;
}

/**
 * Pull username and token data from our state and build an auth header string
 * for use in protected API calls.
 */
export function getAuthHeader() {
  const state = store.getState();
  if (!state.auth || !state.auth.token) {
    return null;
  }
  const token = state.auth.token;
  const username = state.user.data.username;
  const authHeader = authHeaderField(username, token);
  return authHeader;
}




// WEBPACK FOOTER //
// ./src/state/request-auth.js